import { render, staticRenderFns } from "./KitVersionToggle.vue?vue&type=template&id=b613e826&scoped=true&"
import script from "./KitVersionToggle.vue?vue&type=script&lang=js&"
export * from "./KitVersionToggle.vue?vue&type=script&lang=js&"
import style0 from "./KitVersionToggle.vue?vue&type=style&index=0&id=b613e826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b613e826",
  null
  
)

export default component.exports